export enum AppEnv {
  dev = 'dev',
  ready = 'ready',
  pre = 'pre',
  prd = 'prd',
}

export enum PageType {
  HandWrited,
  Generated,
}

export enum LanguageCode {
  ZhTw = 'zh-tw',
  En = 'en',
  Th = 'th',
  In = 'in', // 印尼语
  ZhCn = 'zh-cn',
  Es = 'es', // 西班牙语
  Pt = 'pt', // 葡萄牙语
  Vi = 'vi', // 越南
  Ko = 'ko', // 韩语
  Ja = 'ja', // 日文
  Fr = 'fr', // 法语
  De = 'de', // 德语
  Ru = 'ru', // 俄语
}

export enum UserType {
  Inner = 'inner',
  Outer = 'outer',
  Tool = 'tool',
}

export enum Status {
  Enable = 'enable',
  Disable = 'disable',
}

export enum RoleType {
  Application = 1,
  Data = 2,
}

export enum ActionType {
  Copy = 'copy',
  Edit = 'edit',
  Add = 'add',
}
